import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Container, Typography, Grid } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import PropTypes__default from 'prop-types';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    iconLegend: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: theme.spacing(1)
    },
    img: {
      maxWidth: "100%",
      borderRadius: theme.spacing(2)
    },
    imageDescription: _defineProperty({
      color: theme.palette.grey["800"],
      marginTop: theme.spacing(1)
    }, theme.breakpoints.down("xs"), {
      marginTop: theme.spacing(0.5)
    }),
    legend: _defineProperty({
      paddingBottom: theme.spacing(3.75)
    }, theme.breakpoints.down("sm"), {
      paddingBottom: theme.spacing(2)
    }),
    mt3point5: _defineProperty({}, theme.breakpoints.down("xs"), {
      marginTop: theme.spacing(3.5)
    }),
    legendText: {
      color: theme.palette.grey[800]
    },
    titleText: {
      padding: theme.spacing(2)
    },
    greenHighlightedTitle: {
      background: "linear-gradient(bottom, ".concat(theme.palette.primary[100], " 60%, transparent 40%)"),
      display: "inline",
      height: theme.spacing(4.5)
    }
  };
});
var useBottomStyles = makeStyles(function (theme) {
  return {
    iconLegend: {
      marginRight: theme.spacing(1)
    },
    img: {
      maxWidth: "100%",
      borderRadius: theme.spacing(2)
    },
    imageDescription: _defineProperty({
      color: theme.palette.grey["800"],
      marginTop: theme.spacing(1)
    }, theme.breakpoints.down("xs"), {
      marginTop: theme.spacing(0.5)
    }),
    legend: _defineProperty(_defineProperty({
      padding: theme.spacing(5)
    }, theme.breakpoints.down("sm"), {
      padding: theme.spacing(0, 3, 2.5, 0)
    }), theme.breakpoints.down("xs"), {
      padding: theme.spacing(0, 0, 2.5, 0)
    }),
    legendText: {
      color: theme.palette.black
    },
    mt3point5: _defineProperty({}, theme.breakpoints.down("sm"), {
      marginTop: theme.spacing(3.5)
    }),
    titleText: {
      padding: theme.spacing(2, 0)
    },
    greenHighlightedTitle: {
      background: "linear-gradient(bottom, ".concat(theme.palette.primary[100], " 60%, transparent 40%)"),
      display: "inline",
      height: theme.spacing(4.5)
    },
    variantType: _defineProperty({
      display: "flex",
      flexDirection: "row",
      justifyContent: "center"
    }, theme.breakpoints.down("xs"), {
      flexDirection: "column"
    })
  };
});
var ImageLegend = function ImageLegend(_ref) {
  var title = _ref.title,
    titleStyle = _ref.titleStyle,
    mobileImageTitle = _ref.mobileImageTitle,
    mobileImageUrl = _ref.mobileImageUrl,
    desktopImageTitle = _ref.desktopImageTitle,
    desktopImageUrl = _ref.desktopImageUrl,
    legendItems = _ref.legendItems,
    bgColor = _ref.bgColor,
    gridColumns = _ref.gridColumns,
    gridSpacing = _ref.gridSpacing,
    variant = _ref.variant,
    mobileImageDescription = _ref.mobileImageDescription,
    desktopImageDescription = _ref.desktopImageDescription;
  var classes;
  var _window = window,
    width = _window.innerWidth;
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen;
  if (variant === "bottom") {
    classes = useBottomStyles();
  } else {
    classes = useStyles();
  }
  var getDesktopImgWidth = function getDesktopImgWidth(variant, width) {
    if (variant === "bottom") {
      if (width > 1200) {
        return 1200;
      } else {
        return width;
      }
    } else {
      if (width > 1200) {
        return 600;
      } else {
        return width / 2;
      }
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    pb: 7
  }, /*#__PURE__*/React__default.createElement(Container, null, title && /*#__PURE__*/React__default.createElement(Box, {
    textAlign: titleStyle !== null && titleStyle !== void 0 && titleStyle.textAlignment ? titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.textAlignment.toLowerCase() : "center",
    className: classes.titleText
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: titleStyle !== null && titleStyle !== void 0 && titleStyle.headingVariant ? titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.headingVariant : "h2",
    className: (titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.headingStyle) === "Green highlighted" ? classes.greenHighlightedTitle : ""
  }, title)), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: isExtraSmallScreen() ? 0 : gridSpacing,
    alignItems: "center",
    justify: "center"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: gridColumns ? 12 / gridColumns : 12
  }, /*#__PURE__*/React__default.createElement(Box, {
    align: "center"
  }, (mobileImageUrl || desktopImageUrl) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: isExtraSmallScreen() ? retrieveContentfulImage(mobileImageUrl, {
      width: width - 32
    }) : retrieveContentfulImage(desktopImageUrl, {
      width: getDesktopImgWidth(variant, width)
    }),
    className: classes.img,
    alt: isExtraSmallScreen() ? mobileImageTitle || "" : desktopImageTitle || ""
  })), /*#__PURE__*/React__default.createElement(Box, {
    align: "center"
  }, (mobileImageDescription || desktopImageDescription) && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    className: classes.imageDescription
  }, isExtraSmallScreen() ? mobileImageDescription : desktopImageDescription))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    sm: gridColumns ? 12 / gridColumns : 12,
    className: classes.mt3point5
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: classes.variantType
  }, legendItems && legendItems.map(function (i, index) {
    return /*#__PURE__*/React__default.createElement(Box, {
      key: index,
      display: "flex",
      className: classes.legend
    }, (i === null || i === void 0 ? void 0 : i.url) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      src: retrieveContentfulImage(i === null || i === void 0 ? void 0 : i.url, {
        width: 24,
        height: 24
      }),
      className: classes.iconLegend,
      alt: "Item icon"
    }), (i === null || i === void 0 ? void 0 : i.text) && /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body1",
      className: classes.legendText
    }, i === null || i === void 0 ? void 0 : i.text));
  }))))));
};
ImageLegend.propTypes = {
  title: PropTypes__default.string,
  titleStyle: PropTypes__default.shape({
    textAlignment: PropTypes__default.string,
    headingVariant: PropTypes__default.string,
    headingStyle: PropTypes__default.string
  }),
  bgColor: PropTypes__default.string,
  gridColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12]),
  gridSpacing: PropTypes__default.number,
  legendItems: PropTypes__default.array,
  mobileImageTitle: PropTypes__default.string,
  mobileImageUrl: PropTypes__default.string,
  desktopImageTitle: PropTypes__default.string,
  desktopImageUrl: PropTypes__default.string,
  variant: PropTypes__default.oneOf(["right", "bottom"]),
  mobileImageDescription: PropTypes__default.string,
  desktopImageDescription: PropTypes__default.string
};

export { ImageLegend as default };
//# sourceMappingURL=ImageLegend.js.map
